
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/hope-for-homes-home",
      function () {
        return require("private-next-pages/archive/hope-for-homes-home.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/hope-for-homes-home"])
      });
    }
  